import React, { useState, useEffect } from 'react';
import { Input, Spinner, Label } from 'reactstrap';
import { ConfirmDelete } from './ConfirmDelete';

export function CompanyRow({ company, onFeatureToggle }) {
    const [hasRomanakAccess, setHasRomanakAccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const token = localStorage.getItem("token");

    // Load current Romanak Plot feature access
    useEffect(() => {
        const loadFeatureAccess = async () => {
            if (!company?.id) return;

            try {
                const response = await fetch(`/api/FeatureAccess/company/${company.id}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`   // or however you store the JWT
                        }
                    });

                if (response.ok) {
                    const data = await response.json();
                    const record = Array.isArray(data) && data.length > 0 ? data[0] : null;

                    if (record?.features) {
                        const value = record.features.RomanakPlot ??
                                     false;

                        setHasRomanakAccess(
                            value === true ||
                            value === "true" ||
                            value === "True" ||
                            value === "1"
                        );
                    }
                }
            } catch (err) {
                console.error(`Failed to load Romanak Plot access for company ${company.id}`, err);
            }
        };

        loadFeatureAccess();
    }, [company.id, token]);

    const handleRomanakToggle = async (e) => {
        const newValue = e.target.checked;
        setLoading(true);

        try {
            const response = await fetch(`/api/FeatureAccess/company/${company.id}/RomanakPlot`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ RomanakPlot: newValue })
            });

            if (response.ok) {
                setHasRomanakAccess(newValue);
                if (onFeatureToggle) onFeatureToggle(company.id, newValue);
            } else {
                setHasRomanakAccess(!newValue);
            }
        } catch (err) {
            console.error("Error toggling Romanak Plot access:", err);
            setHasRomanakAccess(!newValue);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (c) => {
        fetch(`api/companies/${c.id}`, {
            method: 'DELETE',
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(resp => resp.ok ? setDeleted(true) : setDeleted(false))
        .catch(e => console.log(e));
        deleteToggle();
    };

    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    if (deleted) return null;

    return (
        <tr>
            <td></td>
            <td>{company.id}</td>
            <td>{company.companyName || company.CompanyName}</td>

            {/* Romanak Plot Access Column - Safari-safe separate elements */}
            <td className="text-left align-middle py-3">
                <div style={{ display: 'inline-flex' }}>
                    <Input
                        type="checkbox"
                        id={`romanak-${company.id}`}
                        checked={hasRomanakAccess}
                        disabled={loading}
                        onChange={handleRomanakToggle}
                        style={{
                            transform: 'scale(1.4)',
                            marginLeft: '8px',
                        }}
                    />
                    <Label
                        htmlFor={`romanak-${company.id}`}
                        style={{
                            marginBottom: 0,
                            marginLeft: '10px',
                            cursor: 'pointer',
                            fontSize: '0.95rem',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        Romanak Plot
                    </Label>
                </div>

                {loading && (
                    <div className="mt-2">
                        <Spinner size="sm" color="primary" />
                    </div>
                )}
            </td>

            {/* Actions Column */}
            <td>
                <ConfirmDelete
                    deleteMessage={`${company.companyName || company.CompanyName} from the database. (It is your responsibility to verify that no users or boards are associated with this company name before you delete it!)`}
                    buttonLabel="Delete"
                    deleteSelected={() => handleDelete(company)}
                    deleteModal={deleteModal}
                    deleteToggle={deleteToggle}
                />
            </td>
        </tr>
    );
}